import { concat, Observable, of } from 'rxjs';
import { filter, mergeMap, pluck, switchMap, take } from 'rxjs/operators';
import { execute as restCustomerMe } from '@wearejh/swagger-rxjs/lib/GetV1CustomersMe';
import { ofType } from 'redux-observable';
import { DataStatus, EpicDeps } from '@wearejh/m2-pwa-engine/lib/types';
import { catchable } from '@wearejh/swagger-rxjs/utils/ajax-helpers';

import { UserActions, UserMsg } from '../user.actions';
import { UserSession } from '../user.reducer';

/**
 * This will refresh the user-data on every page-reload
 * if the user is signed in
 *
 * @param action$
 * @param state$
 * @param deps
 */
export function refreshEpic(action$: Observable<any>, state$: Observable<any>, deps: EpicDeps) {
    return concat(
        state$.pipe(
            pluck('user', 'session'),
            take(1), // only read this value once
            filter((x) => x === UserSession.SignedIn),
        ),
        action$.pipe(ofType<UserActions>('User.Refresh')),
    ).pipe(
        switchMap(() => {
            return concat(
                of(UserMsg('User.SetStatus', DataStatus.Pending)),
                restCustomerMe(deps).pipe(
                    mergeMap((x) =>
                        of(
                            UserMsg('User.SetData', x),
                            UserMsg('User.SetStatus', DataStatus.Success),
                            UserMsg('User.Persist'),
                        ),
                    ),
                    catchable(({ error, status }) => {
                        /**
                         * We ALWAYS want to send these 2 errors
                         * (1 to show which error occured, the other to perform the logout)
                         * but for 401 specifically we want to append
                         * "User.Unauthenticated" too so that consumers are aware
                         */
                        const base$ = of(UserMsg('User.RefreshError', error), UserMsg('User.SignOut'));
                        if (status === 401) {
                            return concat(base$, of(UserMsg('User.Unauthenticated')));
                        }
                        return base$;
                    }),
                ),
            );
        }),
    );
}
